/**
 * Updates empty-catalog total from an unfiltered grid fetch.
 * Never demotes a known positive catalog to 0 — that race (failed search
 * clear / stale empty payload) hides the whole toolbar via showEmptyCatalogState.
 */
export function applyCatalogTotalFromFetch(setCatalogTotalRecords, records) {
  const count = Number(records) || 0;
  setCatalogTotalRecords((prev) =>
    count > 0 || prev == null ? count : prev
  );
}

/**
 * Sets catalog total after a real local mutation (delete/add).
 * Allows 0 when the last record was removed.
 */
export function applyCatalogTotalFromMutation(setCatalogTotalRecords, records) {
  setCatalogTotalRecords(Number(records) || 0);
}
